import type { ReactNode } from 'react';
import { useDialog } from '@workramp/ui';
import { useCallback, useEffect, useRef } from 'react';
import { ExpandedImageModal } from '../ExpandedImageModal';
import { StyledImageExpander } from './ImageExpander.styles';

export const ImageExpander = ({ children }: { children: ReactNode }) => {
  const expandedImageModal = useDialog(ExpandedImageModal);
  const ref = useRef<HTMLDivElement>();

  const handleClick = useCallback(
    (event) => {
      const clickedElement = event.target;
      if (clickedElement.nodeName === 'IMG') {
        expandedImageModal.open({
          imgUrl: clickedElement.getAttribute('src'),
          imgAlt: clickedElement.getAttribute('alt'),
          onClose: expandedImageModal.close,
        });
      }
    },
    [expandedImageModal],
  );

  useEffect(() => {
    const element = ref.current;

    if (element) {
      element.addEventListener('click', handleClick);
    }

    return () => {
      element.removeEventListener('click', handleClick);
    };
  }, [handleClick]);

  return <StyledImageExpander ref={ref}>{children}</StyledImageExpander>;
};
